import { all, fork } from "redux-saga/effects";
import RuleSaga from "./rule/sagas";
import SettingSaga from "./setting/sagas";
import RegistrationSaga from "./registration/sagas";
import UserInfoSaga from "./user/sagas";

export default function* rootSaga() {
  yield all([fork(UserInfoSaga)]);
  yield all([fork(SettingSaga)]);
  yield all([fork(RuleSaga)]);
  yield all([fork(RegistrationSaga)]);
}
